module.exports = __webpack_public_path__ + "static/img/money-bag.230ce1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/menu/money-bag.svg
// module id = ZCN2
// module chunks = 1